import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchSpecialRequests } from "../actions/fetchSpecialRequests.actions";
import { useScopeOfWork } from "../../../context/ScopeOfWorkContext";

export const useSpecialRequestsPagination = () => {
  const [page, setPage] = useState(1);
  const { state } = useScopeOfWork();
  const categoryParam = state.category?.uid ?? state.category?.name ?? "";

  useEffect(() => {
    setPage(1);
  }, [categoryParam]);

  const query = useQuery({
    queryKey: ["special-requests", page, categoryParam],
    queryFn: () =>
      fetchSpecialRequests(page, 10, categoryParam ? { category: categoryParam } : undefined),
  });

  const goNextPage = () => {
    if (query.data && page < query.data.totalPages) {
      setPage((p) => p + 1);
    }
  };

  const goPrevPage = () => {
    if (page > 1) {
      setPage((p) => p - 1);
    }
  };

  return {
    ...query,
    items: query.data?.items ?? [],
    page,
    totalPages: query.data?.totalPages ?? 1,
    goNextPage,
    goPrevPage,
  };
};
